import i18n from '../../i18n';
import { Field } from 'formik';

import { BaseDatePicker } from '../BaseDatePicker/BaseDatePicker';
import AppConfig from '../../providers/AppConfig';

export const DatePickerField = ({ name, label, disabled = false, disabledDate = null, placeholder = null }) => (
  <Field
    component={BaseDatePicker}
    name={name}
    label={label}
    disabled={disabled}
    disabledDate={disabledDate}
    format={AppConfig.defaultDateFormat}
    placeholder={placeholder || i18n.t('common:request.form.placeholders.date')}
    data-testid={name}
  />
);

export default DatePickerField;
